'use strict';

module.exporst = tbsv;

function tbsv () {
  console.error('TBSV (triangular banded matrix solver) not yet implemented');
}
